import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Archive Marker Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-archive-marker-outline',
    templateUrl: './icon-archive-marker-outline.component.html',
    styleUrls: ['./icon-archive-marker-outline.component.scss'],
    standalone: false
})
export class IconArchiveMarkerOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
